import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface SelectOption {
  value: string;
  label: string;
}

interface SelectFieldProps {
  value: string;
  onChange: (_value: string) => void;
  options: SelectOption[];
  placeholder?: string;
  hasError?: boolean;
  className?: string;
}

export default function SelectField({
  value,
  onChange,
  options,
  placeholder = 'Selecione uma opção',
  hasError = false,
  className = ''
}: SelectFieldProps) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className={`w-full ${hasError ? 'border-red-500' : ''} ${className}`}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
